// Swap broken <img> sources to a configured fallback URL at runtime.
// Opt-in: place [data-js-image-fallback-uri="..."] on any ancestor of the <img>.
// `error` events do not bubble, so we attach a single document-level listener in capture phase
// so dynamically-loaded images (e.g. lazysizes-activated) are also covered.
export default class ImageFallback {
    static init() {
        document.addEventListener('error', (event) => {
            const img = event.target;
            if (!(img instanceof HTMLImageElement)) return;
            if (img.dataset.fallbackApplied === 'true') return;

            const wrapper = img.closest('[data-js-image-fallback-uri]');
            if (!wrapper) return;

            const fallback = wrapper.dataset.jsImageFallbackUri;
            if (!fallback) return;

            // Drop <source> siblings so the browser does not keep retrying webp variants
            const picture = img.closest('picture');
            if (picture) {
                picture.querySelectorAll('source').forEach((source) => source.remove());
            }

            // Guard against loops if the fallback itself were to fail
            img.dataset.fallbackApplied = 'true';
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = fallback;
        }, true);
    }
}
